class ApiError extends Error {
  constructor(httpStatusCode, httpStatusText, responseCode, message) {
    super(message);
    this.httpStatusCode = httpStatusCode;
    this.httpStatusText = httpStatusText;
    this.responseCode = responseCode;
  }
}

export const parseApiResponse = (response) => {
  if(response !== undefined) {
    return response.text().then(function(text) {
      let resp = text ? JSON.parse(text) : {};
      if(!resp.status) {
        return resp.message;
      } else {
        return resp;
      }
    });
  } else {
    throw new Error('Response is Required');
  }
};